import React from "react";
import { useNavigate } from "react-router-dom";
import flowImage from "../../assets/images/flowImage.png";
import roomIcon from "../../assets/icons/roomIcon.png";
import subscriberIcon from "../../assets/icons/peopleIcon.png"; // İkon dosyanız

const TemplateCard = ({ template }) => {
  const navigate = useNavigate();

  const handleReactFlow = () => {
    navigate(`/templates/${template.id}`);
  };

  return (
    <div
      className="w-full max-w-[250px] mx-auto border border-gray-300 rounded-lg overflow-hidden bg-white shadow-sm hover:shadow-md transition"
      onClick={handleReactFlow}
    >
      {/* Top Image */}
      <img
        src={flowImage}
        alt={`${template.name} Preview`}
        className="w-full h-28 object-cover rounded-t-lg"
      />

      {/* Content */}
      <div className="p-3">
        {/* Icon and Title */}
        <div className="flex items-center mb-1">
          <img src={roomIcon} alt="Template Icon" className="w-8 h-8 mr-2" />
          <div>
            <h2 className="text-sm font-medium text-gray-800">
              {template.name}
            </h2>
            <p className="text-xs text-gray-500">{template.case}</p>
          </div>
        </div>

        {/* Footer Details */}
        <div className="flex justify-between items-center text-xs text-gray-600 mt-3">
          <span>{template.date}</span>
          <div className="flex items-center">
            <span className="mr-1">{`Subscribers ${template.subscriber}`}</span>
            <img
  src={subscriberIcon}
  alt="icon"
  style={{
    width: "17px", // Daha küçük boyut
    height: "15px",
    filter: "invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(98%) contrast(87%)",
  }}
/>


            
          </div>
        </div>
      </div>
    </div>
  );
};

export default TemplateCard;
